import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { ACCESS_TOKEN } from '@/store/mutation-types'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach((to, from, next) => {
  const { serviceId, systemCode } = to.params
  NProgress.start() // start progress bar

  // 根据路径参数实现自动登录
  if (to.query.token) {
    store.dispatch('AutoLogin', to.query)
      .then(() => {
        const { token, needBack, resource, ...other } = to.query
        next({ path: to.path, query: other })
      })
      .catch((needBack) => {
        if (needBack) {
          NProgress.done()
        } else {
          next({ name: 'Index' })
        }
      })
  } else if (to.path.startsWith('/entry') && serviceId && systemCode && Vue.ls.get(ACCESS_TOKEN)) {
    /**
     * 进入应用服务 - 注册子应用
     * 根据接口返回，判断进入正式环境 || 灰度环境
     */
    if (serviceId !== from.params.serviceId || systemCode !== from.params.systemCode) {
      store.dispatch('InitMicroAppsEntry', { serviceId, systemCode })
        .then(({ microApps, pageTypeId }) => {
          // 根据接口返回，生成菜单
          store.dispatch('entry/GenerateMenus', { serviceId, systemCode, microApps, pageTypeId })
            .finally(next)
        })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
